
import React, { Component } from 'react'
import { connect } from 'react-redux'
import CircularProgress from 'material-ui/CircularProgress';
import {List, ListItem} from 'material-ui/List'
import RepairmanCardYelp from './RepairmanCardYelp'
import * as R from 'ramda'
import yelpActions from 'actions/yelp'
import dataActions from 'actions/dataActions'
import { sortSevF, getByType, beautifyPhone } from 'utils/stuff'

let select = (state) => ({
	...state
  , repairmenPhones: R.map((repairman) => repairman.phoneNumber, R.values(getByType(state, 'repairman')))
  , agentsPhones: R.map((agent) => agent.phoneNumber, R.values(getByType(state, 'agent')))
})
const categoriesArray=[
	, "Carpet Installation"
	, "Carpeting"
	, "Chimney Sweeps"
	, "Contractors"
	, "Damage Restoration"
	, "Drywall Installation & Repair"
	, "Electricians"
	, "Fences & Gates"
	, "Fireplace Services"
	, "Flooring"
	, "Garage Door Services"
	, "Gardeners"
	, "Gutter Services"
	, "Handyman"
	, "Heating & Air Conditioning/HVAC"
	, "Home Cleaning"
	, "Home Inspectors"
	, "Keys & Locksmiths"
	, "Landscaping"
	, "Movers"
	, "Painters"
	, "Plumbing"
	, "Pool Cleaners"
	, "Roofing"
	, "Stucco Services"
	, "Tiling"
	, "Tree Services"
	, "Water Heater Installation/Repair"
	, "Window Washing"
]


export class YelpRepaimen extends Component {
	constructor(props){
		super(props);
		this.state = {
			errMess: false,
			noResults: false
		}
	}
	componentWillReceiveProps(next){
		if(
			next.yelp.isOn
			&& (
				(
					next.yelp.category.length
					&& next.repairmenFilters.property != 'All'
				) || (
					next.type == 'Agent'
					&& next.agentsFilters.property != 'All'
					&& next.agentsFilters.type
					&& next.agentsFilters.type.length
				)
			)
			&& (!R.equals(R.omit('results', this.props.yelp), R.omit('results', next.yelp)) || this.props.repairmenFilters.property != next.repairmenFilters.property)){
			let { isOn, offset, category, results, type} = next.yelp
			let property = (next.type != 'Agent')?
				next.data.db[next.repairmenFilters.property].address.replace(/[\r\n\t\v]/g, " ")
				: next.data.db[next.agentsFilters.property].address.replace(/[\r\n\t\v]/g, " ")
			let agentType = next.agentsFilters.type
			let _this = this
			let categoryNow = (next.type != 'Agent')? category : 'Real Estate Agents'
			var auth = {
			  //
			  // Update with your auth tokens.
			  //
			  consumerKey: "SfGaWX1TVr5tReHTqbtRgw",
			  consumerSecret: "bOdQjrTueDBsVCiJBoltt7UuX4s",
			  accessToken: "D_jKW30JmnjzPsv_ZFZMXiOuN9Z9VQUF",
			  // This example is a proof of concept, for how to use the Yelp v2 API with javascript.
			  // You wouldn't actually want to expose your access token secret like this in a real application.
			  accessTokenSecret: "Ol9suCvVFBqyF9yEr5h2rpcaX8E",
			  serviceProvider: {
			    signatureMethod: "HMAC-SHA1"
			  }
			};
			var newURL;
			function hex_sha1(r){return binb2hex(core_sha1(str2binb(r),r.length*chrsz))}function b64_sha1(r){return binb2b64(core_sha1(str2binb(r),r.length*chrsz))}function str_sha1(r){return binb2str(core_sha1(str2binb(r),r.length*chrsz))}function hex_hmac_sha1(r,a){return binb2hex(core_hmac_sha1(r,a))}function b64_hmac_sha1(r,a){return binb2b64(core_hmac_sha1(r,a))}function str_hmac_sha1(r,a){return binb2str(core_hmac_sha1(r,a))}function sha1_vm_test(){return"a9993e364706816aba3e25717850c26c9cd0d89d"==hex_sha1("abc")}function core_sha1(r,a){r[a>>5]|=128<<24-a%32,r[(a+64>>9<<4)+15]=a;for(var n=Array(80),t=1732584193,h=-271733879,e=-1732584194,c=271733878,s=-1009589776,o=0;o<r.length;o+=16){for(var b=t,_=h,f=e,u=c,i=s,d=0;80>d;d++){16>d?n[d]=r[o+d]:n[d]=rol(n[d-3]^n[d-8]^n[d-14]^n[d-16],1);var l=safe_add(safe_add(rol(t,5),sha1_ft(d,h,e,c)),safe_add(safe_add(s,n[d]),sha1_kt(d)));s=c,c=e,e=rol(h,30),h=t,t=l}t=safe_add(t,b),h=safe_add(h,_),e=safe_add(e,f),c=safe_add(c,u),s=safe_add(s,i)}return Array(t,h,e,c,s)}function sha1_ft(r,a,n,t){return 20>r?a&n|~a&t:40>r?a^n^t:60>r?a&n|a&t|n&t:a^n^t}function sha1_kt(r){return 20>r?1518500249:40>r?1859775393:60>r?-1894007588:-899497514}function core_hmac_sha1(r,a){var n=str2binb(r);n.length>16&&(n=core_sha1(n,r.length*chrsz));for(var t=Array(16),h=Array(16),e=0;16>e;e++)t[e]=909522486^n[e],h[e]=1549556828^n[e];var c=core_sha1(t.concat(str2binb(a)),512+a.length*chrsz);return core_sha1(h.concat(c),672)}function safe_add(r,a){var n=(65535&r)+(65535&a),t=(r>>16)+(a>>16)+(n>>16);return t<<16|65535&n}function rol(r,a){return r<<a|r>>>32-a}function str2binb(r){for(var a=Array(),n=(1<<chrsz)-1,t=0;t<r.length*chrsz;t+=chrsz)a[t>>5]|=(r.charCodeAt(t/chrsz)&n)<<32-chrsz-t%32;return a}function binb2str(r){for(var a="",n=(1<<chrsz)-1,t=0;t<32*r.length;t+=chrsz)a+=String.fromCharCode(r[t>>5]>>>32-chrsz-t%32&n);return a}function binb2hex(r){for(var a=hexcase?"0123456789ABCDEF":"0123456789abcdef",n="",t=0;t<4*r.length;t++)n+=a.charAt(r[t>>2]>>8*(3-t%4)+4&15)+a.charAt(r[t>>2]>>8*(3-t%4)&15);return n}function binb2b64(r){for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n="",t=0;t<4*r.length;t+=3)for(var h=(r[t>>2]>>8*(3-t%4)&255)<<16|(r[t+1>>2]>>8*(3-(t+1)%4)&255)<<8|r[t+2>>2]>>8*(3-(t+2)%4)&255,e=0;4>e;e++)n+=8*t+6*e>32*r.length?b64pad:a.charAt(h>>6*(3-e)&63);return n}var hexcase=0,b64pad="",chrsz=8;
			var OAuth;null==OAuth&&(OAuth={}),OAuth.setProperties=function(e,t){if(null!=e&&null!=t)for(var r in t)e[r]=t[r];return e},OAuth.setProperties(OAuth,{percentEncode:function(e){if(null==e)return"";if(e instanceof Array){for(var t="",r=0;r<e.length;++e)""!=t&&(t+="&"),t+=OAuth.percentEncode(e[r]);return t}return e=encodeURIComponent(e),e=e.replace(/\!/g,"%21"),e=e.replace(/\*/g,"%2A"),e=e.replace(/\'/g,"%27"),e=e.replace(/\(/g,"%28"),e=e.replace(/\)/g,"%29")},decodePercent:function(e){return null!=e&&(e=e.replace(/\+/g," ")),decodeURIComponent(e)},getParameterList:function(e){if(null==e)return[];if("object"!=typeof e)return OAuth.decodeForm(e+"");if(e instanceof Array)return e;var t=[];for(var r in e)t.push([r,e[r]]);return t},getParameterMap:function(e){if(null==e)return{};if("object"!=typeof e)return OAuth.getParameterMap(OAuth.decodeForm(e+""));if(e instanceof Array){for(var t={},r=0;r<e.length;++r){var n=e[r][0];void 0===t[n]&&(t[n]=e[r][1])}return t}return e},getParameter:function(e,t){if(!(e instanceof Array))return OAuth.getParameterMap(e)[t];for(var r=0;r<e.length;++r)if(e[r][0]==t)return e[r][1];return null},formEncode:function(e){for(var t="",r=OAuth.getParameterList(e),n=0;n<r.length;++n){var a=r[n][1];null==a&&(a=""),""!=t&&(t+="&"),t+=OAuth.percentEncode(r[n][0])+"="+OAuth.percentEncode(a)}return t},decodeForm:function(e){for(var t=[],r=e.split("&"),n=0;n<r.length;++n){var a=r[n];if(""!=a){var u,o,i=a.indexOf("=");0>i?(u=OAuth.decodePercent(a),o=null):(u=OAuth.decodePercent(a.substring(0,i)),o=OAuth.decodePercent(a.substring(i+1))),t.push([u,o])}}return t},setParameter:function(e,t,r){var n=e.parameters;if(n instanceof Array){for(var a=0;a<n.length;++a)n[a][0]==t&&(void 0===r?n.splice(a,1):(n[a][1]=r,r=void 0));void 0!==r&&n.push([t,r])}else n=OAuth.getParameterMap(n),n[t]=r,e.parameters=n},setParameters:function(e,t){for(var r=OAuth.getParameterList(t),n=0;n<r.length;++n)OAuth.setParameter(e,r[n][0],r[n][1])},completeRequest:function(e,t){null==e.method&&(e.method="GET");var r=OAuth.getParameterMap(e.parameters);null==r.oauth_consumer_key&&OAuth.setParameter(e,"oauth_consumer_key",t.consumerKey||""),null==r.oauth_token&&null!=t.token&&OAuth.setParameter(e,"oauth_token",t.token),null==r.oauth_version&&OAuth.setParameter(e,"oauth_version","1.0"),null==r.oauth_timestamp&&OAuth.setParameter(e,"oauth_timestamp",OAuth.timestamp()),null==r.oauth_nonce&&OAuth.setParameter(e,"oauth_nonce",OAuth.nonce(6)),OAuth.SignatureMethod.sign(e,t)},setTimestampAndNonce:function(e){OAuth.setParameter(e,"oauth_timestamp",OAuth.timestamp()),OAuth.setParameter(e,"oauth_nonce",OAuth.nonce(6))},addToURL:function(e,t){if(newURL=e,null!=t){var r=OAuth.formEncode(t);if(r.length>0){var n=e.indexOf("?");0>n?newURL+="?":newURL+="&",newURL+=r}}return newURL},getAuthorizationHeader:function(e,t){for(var r='OAuth realm="'+OAuth.percentEncode(e)+'"',n=OAuth.getParameterList(t),a=0;a<n.length;++a){var u=n[a],o=u[0];0==o.indexOf("oauth_")&&(r+=","+OAuth.percentEncode(o)+'="'+OAuth.percentEncode(u[1])+'"')}return r},correctTimestampFromSrc:function(e){e=e||"oauth_timestamp";var t=document.getElementsByTagName("script");if(null!=t&&t.length){var r=t[t.length-1].src;if(r){var n=r.indexOf("?");if(!(0>n)){parameters=OAuth.getParameterMap(OAuth.decodeForm(r.substring(n+1)));var a=parameters[e];null!=a&&OAuth.correctTimestamp(a)}}}},correctTimestamp:function(e){OAuth.timeCorrectionMsec=1e3*e-(new Date).getTime()},timeCorrectionMsec:0,timestamp:function(){var e=(new Date).getTime()+OAuth.timeCorrectionMsec;return Math.floor(e/1e3)},nonce:function(e){for(var t=OAuth.nonce.CHARS,r="",n=0;e>n;++n){var a=Math.floor(Math.random()*t.length);r+=t.substring(a,a+1)}return r}}),OAuth.nonce.CHARS="0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz",OAuth.declareClass=function(e,t,r){var n=e[t];if(e[t]=r,null!=r&&null!=n)for(var a in n)"prototype"!=a&&(r[a]=n[a]);return r},OAuth.declareClass(OAuth,"SignatureMethod",function(){}),OAuth.setProperties(OAuth.SignatureMethod.prototype,{sign:function(e){var t=OAuth.SignatureMethod.getBaseString(e),r=this.getSignature(t);return OAuth.setParameter(e,"oauth_signature",r),r},initialize:function(e,t){var r;r=null!=t.accessorSecret&&e.length>9&&"-Accessor"==e.substring(e.length-9)?t.accessorSecret:t.consumerSecret,this.key=OAuth.percentEncode(r)+"&"+OAuth.percentEncode(t.tokenSecret)}}),OAuth.setProperties(OAuth.SignatureMethod,{sign:function(e,t){var r=OAuth.getParameterMap(e.parameters).oauth_signature_method;(null==r||""==r)&&(r="HMAC-SHA1",OAuth.setParameter(e,"oauth_signature_method",r)),OAuth.SignatureMethod.newMethod(r,t).sign(e)},newMethod:function(e,t){var r=OAuth.SignatureMethod.REGISTERED[e];if(null!=r){var n=new r;return n.initialize(e,t),n}var a=new Error("signature_method_rejected"),u="";for(var o in OAuth.SignatureMethod.REGISTERED)""!=u&&(u+="&"),u+=OAuth.percentEncode(o);throw a.oauth_acceptable_signature_methods=u,a},REGISTERED:{},registerMethodClass:function(e,t){for(var r=0;r<e.length;++r)OAuth.SignatureMethod.REGISTERED[e[r]]=t},makeSubclass:function(e){var t=OAuth.SignatureMethod,r=function(){t.call(this)};return r.prototype=new t,r.prototype.getSignature=e,r.prototype.constructor=r,r},getBaseString:function(e){var t,r=e.action,n=r.indexOf("?");if(0>n)t=e.parameters;else{t=OAuth.decodeForm(r.substring(n+1));for(var a=OAuth.getParameterList(e.parameters),u=0;u<a.length;++u)t.push(a[u])}return OAuth.percentEncode(e.method.toUpperCase())+"&"+OAuth.percentEncode(OAuth.SignatureMethod.normalizeUrl(r))+"&"+OAuth.percentEncode(OAuth.SignatureMethod.normalizeParameters(t))},normalizeUrl:function(e){var t=OAuth.SignatureMethod.parseUri(e),r=t.protocol.toLowerCase(),n=t.authority.toLowerCase(),a="http"==r&&80==t.port||"https"==r&&443==t.port;if(a){var u=n.lastIndexOf(":");u>=0&&(n=n.substring(0,u))}var o=t.path;return o||(o="/"),r+"://"+n+o},parseUri:function(e){for(var t={key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/}},r=t.parser.strict.exec(e),n={},a=14;a--;)n[t.key[a]]=r[a]||"";return n},normalizeParameters:function(e){if(null==e)return"";for(var t=OAuth.getParameterList(e),r=[],n=0;n<t.length;++n){var a=t[n];"oauth_signature"!=a[0]&&r.push([OAuth.percentEncode(a[0])+" "+OAuth.percentEncode(a[1]),a])}r.sort(function(e,t){return e[0]<t[0]?-1:e[0]>t[0]?1:0});for(var u=[],o=0;o<r.length;++o)u.push(r[o][1]);return OAuth.formEncode(u)}}),OAuth.SignatureMethod.registerMethodClass(["PLAINTEXT","PLAINTEXT-Accessor"],OAuth.SignatureMethod.makeSubclass(function(e){return this.key})),OAuth.SignatureMethod.registerMethodClass(["HMAC-SHA1","HMAC-SHA1-Accessor"],OAuth.SignatureMethod.makeSubclass(function(e){b64pad="=";var t=b64_hmac_sha1(this.key,e);return t}));try{OAuth.correctTimestampFromSrc()}catch(e){}

			var terms = categoryNow;
			var sort='1'
			var limit='10'
			var radius_filter='30000'
			var accessor = {
			  consumerSecret: auth.consumerSecret,
			  tokenSecret: auth.accessTokenSecret
			};
			var parameters = [];
			parameters.push(['term', terms]);
			parameters.push(['location', property]);
			parameters.push(['sort', sort]);
			parameters.push(['radius_filter', radius_filter]);
			parameters.push(['oauth_consumer_key', auth.consumerKey]);
			parameters.push(['oauth_consumer_secret', auth.consumerSecret]);
			parameters.push(['oauth_token', auth.accessToken]);
			parameters.push(['oauth_signature_method', 'HMAC-SHA1']);
			var message = {
			  'action': 'https://api.yelp.com/v2/search',
			  'method': 'GET',
			  'parameters': parameters
			};
			OAuth.setTimestampAndNonce(message);
			OAuth.SignatureMethod.sign(message, accessor);
			var parameterMap = OAuth.getParameterMap(message.parameters);
			parameterMap.oauth_signature = OAuth.percentEncode(parameterMap.oauth_signature)

			var url= 'https://yelp.lumand.com/v2/search'

			let query ='?' + R.map((key) => key + '=' + parameterMap[key])(R.keys(parameterMap)).join('&')
			fetch(url + query) .then(resp => {
				return resp.json()
			})
			.then(
				data => {
						let repairmenData = R.map((company)=>{
							return{
							firstName: company.name,
								phoneNumber: company.phone,
							distance: (company.distance/1600).toFixed(2),
							email: '',
							address: company.location.display_address.join('\n'),
								categories: (type != 'Agent')?
								[categoryNow, ...R.filter(categoryForCheck=> !!categoryForCheck && categoryForCheck != categoryNow, R.map((category) => (R.any(catName=> !!~categoriesArray.indexOf(catName), category))? category[0]: false, company.categories || []))]
								: (~company.categories.indexOf('Companies'))? 'Companies' : 'Private Persons' ,
								note: '',
								type: "repairman",
								rating: company.rating,
							tasks: [],
							cors: (company.location.coordinate)?
								{
									 lat: company.location.coordinate.latitude,
									 lng: company.location.coordinate.longitude
								}
								: undefined
							,
							id: company.id,
							isYelp: true,
								web: company.url
						}} , data.businesses || [])
						let filteredRep = R.reject(repMan => repMan.rating < 3 || repMan.distance > 50, repairmenData)
						if(!filteredRep.length){
							filteredRep = repairmenData.splice(0, 20)
						}
						_this.props.ADD_RESULTS(R.indexBy(R.prop('id'), filteredRep))
					})
			}
	}
	render() {
		let { isOn, offset, category, results} = this.props.yelp
		let agentType = this.props.agentsFilters.type
		let { type } = this.props
		let property = (type != 'Agent')? this.props.repairmenFilters.property :  this.props.agentsFilters.property
		let propertyObj = this.props.data.db[property] || {}
		let { errMess } = this.state
		return(
			<div style={this.props.style}>
				{(isOn)?
					<div>
						{(typeof global.md.phone() != "string")?<p>Yelp results for {propertyObj.address}</p> : ""}
						{(((category.length && type != 'Agent') || (agentType.length && type == 'Agent')) && property != 'All')?
							<List
								style={{
									backgroundColor: "transparent"
								}}
							>
								{(R.keys(results).length)?
									R.map((repairman) =>(
										<RepairmanCardYelp
											key={`rep-${repairman.id}-${Math.random()}`}
											repairman={repairman}
											id={repairman.id}
											lastInteracted={0}
											property={{
												cors: propertyObj.cors
											  , _id: propertyObj._id
											  , address: propertyObj.address
											}}
											type={type}
											history={this.props.history}
											docUpd={this.props.DOC_UPDATE}
											history={this.props.history}
											userID={this.props.session.userID}
										/>
									),  R.values(
											R.filter((yelpRes) => (type == 'Agent')? !~this.props.agentsPhones.indexOf(beautifyPhone(yelpRes.phoneNumber)) : !~this.props.repairmenPhones.indexOf(beautifyPhone(yelpRes.phoneNumber)), sortSevF(results, {fieldName1: "rating", fieldName2: "distance", asc: false}))
										)
									)
									:(errMess)? <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>{errMess}</p>
								: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No {(type != "Agent")? "repairmen" : "agents"}</p>
								}
							</List>
						: (
							(!category.length && type != 'Agent')
						)?
							<div>Choose category</div>
								: ((!agentType.length || agentType == 'All') && type == 'Agent')?
									<div>Choose agent type</div>
									:<div>Choose property</div>
						}
					</div>
				: <div></div>}
			</div>
		)
	}
}

export default connect(select, R.mergeAll([yelpActions, dataActions]))(YelpRepaimen)



// WEBPACK FOOTER //
// ./src/components/YelpResults.js